import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const watchEntityKeys = ['publicationCompatiblePaginations', 'publications']

function usePublicationCompatiblePaginations(options = {}){
  const { entityKey, filters, performHttpRequests } = options
  const {
    publication_id: filterPublicationId,
  } = filters || {}

  const {
    updatedEntities: {
      publicationCompatiblePaginations: publicationCompatiblePaginationsUpdatedAt,
      publications: publicationsUpdatedAt,
    },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingPublicationCompatiblePaginations } = useReduxAction(
    'publicationCompatiblePaginations',
    'loadPublicationCompatiblePaginations',
    {
      ...defaultRequestOptions.publicationCompatiblePagination,
      ...filters,
    },
    [filters, performHttpRequests],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  const publicationCompatiblePaginations = useSelector(reduxState => (
    reduxState.entities.publicationCompatiblePaginations
  ))
  const publications = useSelector(reduxState => reduxState.entities.publications)

  const filteredPublicationCompatiblePaginations = useMemo(() => {
    const filtered = Object.values(publicationCompatiblePaginations).filter((publicationEdition) => {
      const { publication_id } = publicationEdition

      const matchPublication = matchFilterNumber(publication_id, filterPublicationId)

      return matchPublication
    })

    return sortArrayBy(
      filtered,
      'asc',
      ({ compatible_publication_id }) => publications[compatible_publication_id]?.title,
    )
  }, [publicationCompatiblePaginationsUpdatedAt, publicationsUpdatedAt, JSON.stringify(filters)])

  const hasFilteredPublicationCompatiblePaginations = !!filteredPublicationCompatiblePaginations.length

  const filteredCompatiblePublicationIds = filteredPublicationCompatiblePaginations.map(compatiblePublication => (
    compatiblePublication.compatible_publication_id
  ))

  return {
    filteredCompatiblePublicationIds,
    filteredPublicationCompatiblePaginations,
    hasFilteredPublicationCompatiblePaginations,
    loading: loadingPublicationCompatiblePaginations,
  }
}

export default usePublicationCompatiblePaginations
